import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "sx", "size", "color", "className", "onClick"];
import { IconButton } from "@mui/material";
export var MuiIconButton = function (props) {
    var children = props.children, sx = props.sx, size = props.size, color = props.color, className = props.className, onClick = props.onClick, other = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ React.createElement(IconButton, _extends({
        className: className,
        onClick: onClick,
        size: size || "medium",
        sx: sx || {
            color: color || "black"
        }
    }, other), children);
};
